import React, { useEffect } from 'react';
import clsx from 'clsx'
import Card from '@mui/material/Card';
import PeopleIcon from '@mui/icons-material/People';
import { Avatar, Typography, CardContent, Grid } from '@mui/material'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import { dashboardAction } from '_actions'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 10,
    marginRight: 10,
    minHeight: 120,
    minWidth: 300
  },
  title: {
    fontWeight: 500,
    color: theme.palette.primary.main
  }
}));

const CardUsuarios = (props) => {
  const { className, ...rest } = props
  const classes = useStyles();
  const dispatch = useDispatch();

  const totalUsuarios = useSelector((state) => (state.dashboard ? state.dashboard.dashboard.totalUsuarios : undefined))

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardContent>
        <Grid container justifyContent="space-between">
          <Grid item styles={{ display: 'flex', flexDirection: 'column' }}>
            <Grid item>
              <Typography variant="h5" className={classes.title}>
                {totalUsuarios ? totalUsuarios : 0}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="body2" gutterBottom>
                Total de usuários cadastrados
              </Typography>
            </Grid>
          </Grid>
          <Grid item>
            <Avatar sx={{ width: 65, height: 65, bgcolor: '#F2D647' }}>
              <PeopleIcon sx={{ fontSize: 35, color: '#000' }} />
            </Avatar>
          </Grid>
        </Grid>
      </CardContent>
    </Card >
  );
}

CardUsuarios.propTypes = {
  className: PropTypes.string,
  subtitle: PropTypes.string
}

export default CardUsuarios
